module.exports = __webpack_public_path__ + "img/1526724917.4754f27b.jpg";